<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center gap-2 border border-amber-600/40 bg-zinc-950/95 p-3 text-center sm:p-4"
    role="status"
    :aria-label="`${title}. ${reason}`"
  >
    <AlertTriangle
      class="h-8 w-8 shrink-0 text-amber-500 sm:h-9 sm:w-9"
      aria-hidden="true"
    />
    <p class="text-xs font-semibold uppercase tracking-wide text-amber-200/90">
      {{ title }}
    </p>
    <p class="max-w-md text-xs leading-relaxed text-zinc-300 sm:text-sm">
      {{ reason }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { AlertTriangle } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    /** Why this section is not showing normal content. */
    reason: string
    /** Short heading above the reason. */
    title?: string
  }>(),
  { title: 'Section unavailable' }
)
</script>
